// src/components/Modal.js
import React, { useEffect } from "react";
import { IoClose } from "react-icons/io5";

const Modal = ({ isOpen, onClose, children }) => {
  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };
    document.addEventListener("keydown", handleEscape);
    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, [onClose]);

  if (!isOpen) return null;

  return (
    <div
      className='fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center z-50'
      onClick={onClose}
    >
      <div
        className='relative bg-white p-[10px] sm:p-[40px] rounded-lg shadow-lg w-3/4 max-w-[768px]'
        onClick={(e) => e.stopPropagation()}
      >
        <button className='absolute top-4 right-4 text-gray-600' onClick={onClose}>
          <IoClose size={28}/>
        </button>
        <div>{children}</div>
      </div>
    </div>
  );
};

export default Modal;
